/**
 * 역할 표시명 선택 유틸 (2026-07-15 신설).
 *
 * ★실결함: 역할 셀렉트(사용자 목록 필터·생성 다이얼로그·상세)가 언어와 무관하게 `nameKo` 를
 * 출력해, EN 로케일에서도 "시스템 관리자" 같은 한글 라벨이 남았다(R8-A-011 회귀 테스트가
 * 장기간 red 였던 실제 원인). 서버는 `nameEn` 을 함께 내려주므로 언어에 맞춰 고른다.
 */
import type { RoleListItem } from '../types/user';

/**
 * 현재 언어에 맞는 역할 표시명을 반환한다.
 *
 * @param role     역할 (nameKo 필수 · nameEn 선택)
 * @param language i18n.language (예: 'ko', 'en', 'en-US')
 * @returns EN 로케일이고 nameEn 이 있으면 nameEn, 그 외에는 nameKo
 */
export function roleLabel(
  role: Pick<RoleListItem, 'nameKo' | 'nameEn'>,
  language: string | undefined,
): string {
  const isEn = (language ?? '').toLowerCase().startsWith('en');
  return isEn && role.nameEn ? role.nameEn : role.nameKo;
}
